import i18n from '../i18n'

export default function LoadError ({ onRetry, onBack, missing = false }) {
  return (
    <section role='alert' style={{ padding: '2rem', maxWidth: '640px', margin: 'auto' }}>
      <h2>{i18n.t(missing ? 'documentMissing' : 'loadFailed', { ns: 'common' })}</h2>
      <p>{i18n.t(missing ? 'documentMissingHelp' : 'loadFailedHelp', { ns: 'common' })}</p>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        {onRetry && <button type='button' onClick={onRetry}>{i18n.t('retry', { ns: 'common' })}</button>}
        {onBack && <button type='button' onClick={onBack}>{i18n.t('back', { ns: 'common' })}</button>}
      </div>
    </section>
  )
}
